import * as React from 'react'

import {
  MenuList
} from '@mui/material'

import { styled } from '@mui/material/styles';

const CMenuList = styled(MenuList)({
  paddingTop: 0,
  paddingBottom: 0
});

export {
  CMenuList
}